<section class="profile-awards">
  <div *ngIf="student">
    <a class="award__nav__back" (click)="back()">
      <span><mat-icon>arrow_back</mat-icon></span>
      <span>Назад</span>
    </a>
  </div>
  <div *ngIf="awards">
    <span class="profile-awards__content">
      <ul class="profile-awards__content__list">
        <li *ngFor="let award of awards | slice:0:countShow"
          class="profile-awards__content__list__item">
          <span (click)="openPreviw(award)">
            <app-award [award]="award"></app-award>
          </span>
        </li>
      </ul>
    </span>
    <span class="profile-awards__buttons">
      <button [disabled]="countShow >= awards.length" mat-button (click)="loadNext()">Показать еще: <b>{{ countShow }}</b></button>
      <button [disabled]="countShow >= awards.length" mat-raised-button (click)="showAll()">Показать все</button>
    </span>
  </div>
</section>
